module.exports = "/assets/a120249b46559ce9180b91e47b54ea66.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/C7.png
// module id = 1255
// module chunks = 0